import {
  parseActiveStatusFilter,
  parseBooleanFilter,
  parseNumberFilter,
  parseTextFilter,
  toActiveStatusFilterText,
  toBooleanFilterText,
  toFilterText,
  toNumberListFilterText,
  parseNumberListFilter,
} from '@/utils/filters';
import type { MonitorSearch, ProjectSearch, UploadSearch } from '../types/question.types';

type FilterValues = Record<string, string>;

type MonitorFilterSearch = Pick<
  MonitorSearch,
  | 'projectId'
  | 'userId'
  | 'boardId'
  | 'targetDate'
  | 'isNew'
  | 'collected'
  | 'instituteId'
  | 'subjectIds'
>;

export function toMonitorFilterValues(search: MonitorFilterSearch): FilterValues {
  return {
    projectId: toFilterText(search.projectId),
    userId: toFilterText(search.userId),
    boardId: toFilterText(search.boardId),
    targetDate: toFilterText(search.targetDate),
    isNew: toBooleanFilterText(search.isNew),
    collected: toBooleanFilterText(search.collected),
    instituteId: toFilterText(search.instituteId),
    subjectIds: toNumberListFilterText(search.subjectIds),
  };
}

export function toMonitorFilterSearch(values: FilterValues): MonitorFilterSearch {
  return {
    projectId: parseNumberFilter(values.projectId),
    userId: parseNumberFilter(values.userId),
    boardId: parseNumberFilter(values.boardId),
    targetDate: parseTextFilter(values.targetDate),
    isNew: parseBooleanFilter(values.isNew),
    collected: parseBooleanFilter(values.collected),
    instituteId: parseNumberFilter(values.instituteId),
    subjectIds: parseNumberListFilter(values.subjectIds),
  };
}

type UploadFilterSearch = Pick<
  UploadSearch,
  | 'projectId'
  | 'instituteId'
  | 'instituteName'
  | 'instituteCode'
  | 'instituteEiin'
  | 'divisionName'
  | 'districtName'
  | 'thanaName'
>;

export function toUploadFilterValues(search: UploadFilterSearch): FilterValues {
  return {
    projectId: toFilterText(search.projectId),
    instituteId: toFilterText(search.instituteId),
    instituteName: toFilterText(search.instituteName),
    instituteCode: toFilterText(search.instituteCode),
    instituteEiin: toFilterText(search.instituteEiin),
    divisionName: toFilterText(search.divisionName),
    districtName: toFilterText(search.districtName),
    thanaName: toFilterText(search.thanaName),
  };
}

export function toUploadFilterSearch(values: FilterValues): UploadFilterSearch {
  return {
    projectId: parseNumberFilter(values.projectId),
    instituteId: parseNumberFilter(values.instituteId),
    instituteName: parseTextFilter(values.instituteName),
    instituteCode: parseTextFilter(values.instituteCode),
    instituteEiin: parseTextFilter(values.instituteEiin),
    divisionName: parseTextFilter(values.divisionName),
    districtName: parseTextFilter(values.districtName),
    thanaName: parseTextFilter(values.thanaName),
  };
}

type ProjectFilterSearch = Pick<ProjectSearch, 'isActive'>;

export function toProjectFilterValues(search: ProjectFilterSearch): FilterValues {
  return { isActive: toActiveStatusFilterText(search.isActive) };
}

export function toProjectFilterSearch(values: FilterValues): ProjectFilterSearch {
  return { isActive: parseActiveStatusFilter(values.isActive) };
}
